import React, { useEffect } from 'react';
import './AIInterviewPopUp.css';

const AIInterviewPopup = ({ onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = 'auto'; };
  }, []);

  return (
    <div className="ai-interview-home-popup-overlay">
      <div className="home-popup-box">
        <h2>Boost Your Career with AI Interviews!</h2>
        <p>Get real-time feedback, simulate real interviews, and level up your confidence before facing real employers.</p>
        <div className="popup-buttons">
          <button onClick={() => window.location.href = "/ai-interview"}>AI Interview</button>
          <button onClick={() => window.location.href = "/career-placement-assistance"}>Internship / Job Opportunities</button>
          <button onClick={() => window.location.href = "/live-classes-form"}>Live Classes</button>
        </div>
        <button className="close-btn" onClick={onClose}>×</button>
      </div>
    </div>
  );
};

export default AIInterviewPopup;